'use client'

import { ReactElement } from 'react'

import Script from 'next/script'

import { SETTINGS_GENERAL } from '@/config/settings.general'
import { useCookieConsent } from '@/context/CookieConsentContext'

export default function YandexMetrika(): ReactElement {
    const { analyticsAllowed } = useCookieConsent()

    if (process.env.NODE_ENV !== 'production' || !analyticsAllowed) {
        return <></>
    }

    return (
        <>
            <Script id={'yandex-metrica'} strategy={'afterInteractive'}>
                {`(function(m,e,t,r,i,k,a){
                m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                m[i].l=1*new Date();
                for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
                k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
                })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${SETTINGS_GENERAL.YANDEX_METRIKA_ID}', 'ym');
                ym(${SETTINGS_GENERAL.YANDEX_METRIKA_ID}, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});`}
            </Script>
            <noscript
                dangerouslySetInnerHTML={{
                    __html: `
                        <div>
                            <img src="https://mc.yandex.ru/watch/${SETTINGS_GENERAL.YANDEX_METRIKA_ID}" style="position:absolute; left:-9999px;" alt="" />
                        </div>
                    `,
                }}
            />
        </>
    )
}
